<template>
    <div>
        <MainHeader />

        <b-container fluid class="p-3 p-md-4 p-lg-5">
            <h1>CONDITIONS GÉNÉRALES DE SERVICES</h1>
            <br />
            <h2>Article 1 - CONDITIONS GÉNÉRALES DE SERVICES</h2>
            <p>
                Les dispositions des présentes conditions générales, comme celles prévues au contrat de prestations de services, s'appliquent à toute demande ou fourniture de prestations, nonobstant tout autre disposition contraire des conditions d'achats ou autres documents émanant du client.
            </p>
            <br />
            <h2>Article 2 - PRESTATIONS DU CENTRE ELYSEE SERVICES</h2>
            <p>
                Le Centre ELYSEE SERVICES est un centre proposant des services multiples et complémentaires : services de domiciliation d'entreprises, permanence téléphonique, mise à disposition d'un bureau équipé, service de secrétariat, standard téléphonique, bureautique, accueil, correspondance, télésecrétariat, etc…
                <br />
                Les prestations sont fournies par le centre ELYSEE SERVICES :
            </p>
            <ul>
                <li>
                    Par souscription d'un abonnement (ex : contrat de domiciliation, mise à disposition du bureau, standard téléphonique) pour une durée déterminée ou indéterminée.
                </li>
                <li>
                    Par commande ponctuelle de services (ex : prestations de secrétariat, de télésecrétariat, etc…)
                </li>
            </ul>
            <p>
                Les tarifs des prestations du centre ELYSEE SERVICES sont régulièrement mis à jour. Les tarifs applicables sont ceux en vigueur le jour de la commande.
            </p>
            <br />
            <h2>Article 3 - COMMANDES</h2>
            <p>
                Les commandes de services ou de mise à disposition de lieux ou d'équipements sont fermes et définitives pour le client dès leur émission. Elles devront toutefois, pour engager le centre ELYSEE SERVICES, faire l'objet d'une acceptation expresse de sa part. Toute annulation de commande de la part du client manifestée plus de 8 jours avant la date prévue pour son exécution donnera toutefois lieu au règlement d'une indemnité égale à 20 % de l'intégralité des prix de la prestation prévue.
                <br />
                En cas d'annulation manifestée moins de 8 jours avant la date prévue pour son exécution (ex : mise à disposition d'un bureau), le prix de la prestation prévue restera dû dans son intégralité.
            </p>
            <br />
            <h2>Article 4 - DÉLAIS DE RÉALISATION</h2>
            <p>
                Les délais de réalisation des prestations sont établis en toute bonne foi par le Centre ELYSEE SERVICES qui s'efforce de les respecter. Ces délais ont, en conséquence, un caractère seulement indicatif. Un retard par rapport aux délais ne saurait donc être invoqué comme cause d'annulation des commandes, ni donner droit à une indemnité quelconque au profit du client.
                <br />
                Le client aura toutefois la faculté de se considérer comme délié de sa commande si la prestation réclamée n'a pas pu être exécutée par le Centre ELYSEE SERVICES dans un délai double de celui indiqué. En pareil cas, le client doit notifier par écrit son désistement au Centre ELYSEE SERVICES.
            </p>
            <br />
            <h2>Article 5 - MODALITES D'EXECUTION DES SERVICES</h2>
            <p>
                Le Centre ELYSEE SERVICES détermine les conditions de commande et d'exécution des services qu'il propose.
            </p>
            <br />
            <h2>Article 6 - RECLAMATIONS, RESPONSABILITE ET GARANTIE D'ELYSEE SERVICES</h2>
            <p>
                6.1- Le Centre ELYSEE SERVICES s'efforce de fournir la meilleure prestation. Les prestations de services sont réalisées sous la seule garantie de leur bonne exécution matérielle par le Centre ELYSEE SERVICES à l'exclusion de toute autre. Le Centre ELYSEE SERVICES n'assure en conséquence aucune garantie de dommages indirects, résultant d'un défaut d'exécution. Il en est notamment ainsi pour les prestations de standard et de secrétariat qui dépendent de la bonne perception des informations (audibilité des communications, élocution de l'interlocuteur, écriture des documents à dactylographier). Un certain nombre de prestations sont effectuées pour les clients par des tiers prestataires (ex : entreprise de transport, coursier, informatique,etc…)
                <br />
                Ces prestations sont effectuées sous la seule responsabilité du tiers prestataire, sans que celle du Centre ELYSEE SERVICES puisse être mise en cause.
                <br />
                Il en sera notamment ainsi en cas de perte ou dommages causés aux biens ou plis transportés et aux matériels mis à disposition.
                <br />
                Il en sera de même en cas de demande d'interventions de tiers extérieurs au Centre ELYSEE SERVICES directement sollicités par le client. En pareil cas le client s'oblige à demander l'autorisation expresse du Centre ELYSEE SERVICES à cette intervention extérieure, à garantir personnellement au Centre ELYSEE SERVICES tout préjudice que le Centre ELYSEE SERVICES pourrait subir de cette intervention (dégradation, incendie, vol, etc…) et à décharger le Centre ELYSEE SERVICES de toute réclamation ou réparation du préjudice qu'il pourrait personnellement subir du tiers extérieur.
                <br />
                Toute réclamation concernant les prestations de services assurées par le Centre ELYSEE SERVICES devra être formulée immédiatement et au plus tard le lendemain du jour de réception. Aucune réclamation ne pourra être admise après.
                <br /> <br />
                6.2- Le client renonce à tout recours contre le Centre ELYSEE SERVICES et contre le propriétaire des locaux pour tous dommages directs ou indirects (ex : perte d'exploitation) consécutifs :
            </p>
            <ul>
                <li>A un sinistre dans les locaux</li>
                <li>
                    A la suppression temporaire de l'électricité (il appartient au client seul de se prémunir ou pas (ondulateur) de toutes coupures de courant intempestives pouvant affecter la sauvegarde de ses opérations), de l'eau, des moyens de télécommunication (dont la perte de connectivité Internet) ou des services de tiers (ex : transport, coursier, traiteur)
                </li>
                <li>
                    Aux vols, cambriolages, troubles entravant la jouissance par le fait de tiers (grèves, manifestations, travaux sur la voie publique, acte de vandalisme ou de banditisme)
                </li>
                <li>
                    ou toutes autres raisons liées à la force majeure
                </li>
            </ul>
            <br />
            <h2>Article 7 - OBLIGATIONS DU CLIENT</h2>

            <h3>7.1 - Information et notification </h3>
            <p>Le client s'engage à :</p>
            <ul>
                <li>
                    Communiquer le nom et l'adresse personnelle de son représentant légal qui déclare accepter toute notification pour le compte de l'entreprise qu'il représente à son domicile personnel
                </li>
                <li>
                    Communiquer dans les 30 jours un extrait justifiant son inscription au Registre du Commerce des Sociétés
                </li>
                <li>
                    Informer régulièrement le Centre ELYSEE SERVICES de toute modification concernant sa forme juridique, son objet, le nom et l'adresse des personnes ayant le pouvoir de l'engager
                </li>
                <li>
                    Informer sans délai le Centre ELYSEE SERVICES de tout état de cessation des paiements, de procédure collective, de redressement ou de liquidation judiciaire
                </li>
            </ul>
            <p>
                Dans le cas d'un siège social ou d'un établissement secondaire, le client doit communiquer sur simple requête du Centre ELYSEE SERVICES et par retour du courrier, le nom et l'adresse de son comptable et le lieu de facturation et de conservation de ses documents comptables et officiels concernant sa société.
                <br />
                Dans le cadre particulier d'une domiciliation fiscale, le client déclare être informé du contrôle strict exercé en la matière par les administrations en général, et l'administration fiscale en particulier. En pareil cas, le Centre ELYSEE SERVICES s'engage à communiquer promptement au client toute demande de l'administration (en général) qu'il lui aurait été notifié.
                <br />
                En application des textes de lois, règlements et circulaires administratives en vigueur, le client s'oblige alors sur simple requête du Centre ELYSEE SERVICES de l'administration (fiscale ou autre) ou tout autre organisme, à répondre à toute première demande dans les délais les plus brefs.
                <br />
                Le non respect de obligation d'information, due aux administrations par le client et demeurée vaine, décharge totalement le Centre ELYSEE SERVICES de toute responsabilité, le client devant assumer seul les conséquences de sa non réponse.
                <br />
                Ce défaut d'information pourra à lui seul constituer une cause de résiliation du contrat dans le cadre de l'article 9 suivant, sans que le client ne puis prétendre à la moindre indemnité.
            </p>

            <h3>7.2 - Responsabilité</h3>
            <p>
                Le client assume seul la responsabilité de son activité et agira en toute matière de sorte que le Centre ELYSEE SERVICES ne puisse jamais être inquiété, mis en cause ou recherché. Le client assumera seul la responsabilité des dommages que pourraient subir ou causer ses préposés, clients et autres visiteurs. Il se porte garant du respect  par ces personnes des dispositions contractuelles.
            </p>

            <h3>7.3 - Utilisation des bien et préstations</h3>
            <p>
                7.3.1- Le client s'engage à utiliser les biens mis à sa disposition dans des conditions conformes à leur destination dans le Centre ELYSEE SERVICES. Le client assumera l'entière responsabilité de dégradation ou pertes de biens aux lieux mis à disposition. Une indemnité correspondant au coût de remise en état ou de remplacement et à la perte résultant de l'impossibilité d'utiliser les biens ou les lieux pendant la durée de la remise en état, sera mise à sa charge. Cette indemnité ne peut se limiter au dépôt de garantie consenti par le client.
                <br /> <br />
                7.3.2- Le client s'engage à utiliser les prestations du Centre ELYSEE SERVICES pour des actes d'exploitation normale de son activité dans la limite de la légalité. Il devra notamment utiliser les services de standard téléphonique dans des conditions normales et usuelles (ex : toute opération de publicité ou recrutement qui utiliserait les numéros de téléphone ou de fax du Centre ELYSEE SERVICES devra au préalable être agréée par le Centre ELYSEE SERVICES).
                <br /> <br />
                7.3.3-Le client s'interdit, pour ses affaires personnelles et sa correspondance, d'utiliser l'enseigne ELYSEE SERVICES ainsi que le  nom et le sigle de la société exploitant le centre y compris dans le libellé de son adresse  postale.
            </p>

            <h4>7.3.4 - Non-concurrence</h4>
            <p>Le client s'interdit :</p>
            <ul>
                <li>
                    de proposer aux autres clients du Centre ELYSEE SERVICES des prestations concurrentes de celles offertes par le Centre ELYSEE SERVICES.
                </li>
                <li>
                    de débaucher de quelque façon que ce soit, l'un des membres quelconques du personnel du Centre ELYSEE SERVICES, sous peine d'action judiciaire entamée par le Centre ELYSEE SERVICES pour dédommagement.
                </li>
                <li>
                    de créer une activité concurrente, proposant un ou plusieurs services du Centre ELYSEE SERVICES dans un délai de deux ans.
                </li>
            </ul>

            <h4>7.3.5 - Consommation de services</h4>
            <p>
                Le client reconnaît que le Centre ELYSEE SERVICES est un prestataire de services dont la vocation est d 'offrir à sa clientèle des services variés, accueil, bureau, secrétariat, standard téléphonique, etc…
                <br />
                Le client renonce en conséquence à exercer dans les locaux d'ELYSEE SERVICES des prestations qui seraient proposées habituellement par le Centre ELYSEE SERVICES.
            </p>
            <br />
            <h2>Article 8 - PAIEMENT</h2>
            <p>
                Les prestations du Centre ELYSEE SERVICES sont payées :
            </p>
            <ul>
                <li>
                    par abonnement forfaitaire (ex : services de domiciliation, services de standard téléphonique, etc…)
                </li>

                <li>sur facturation ponctuelle</li>
            </ul>
            <p>
                8.1 - Le services fournis sur abonnement sont payés trimestriellement et d'avance, sauf convention différente mentionnée dans les conditions particulières.
                <br /> <br />
                8.2 - Les autres prestations de services sont payées comptant au jour de leur exécution. Le Centre ELYSEE SERVICES pourra toutefois décider de procéder à une facturation mensuelle des prestations effectuées au cours du mois, une provision d'un montant égal à 80 % du volume prévu de consommation sera alors versée par le client. Le règlement de la facture devra intervenir au plus tard le 15 du mois suivant celui d'exécution des prestations, sauf convention différente mentionnée dans les conditions particulières.
                <br /> <br />
                8.3 - Toute demande d'explication ou toute contestation éventuelle de facture devra intervenir dans le mois de son émission, les justificatifs des prestations n'étant conservées que pendant ce délai.
            </p>
            <br />
            <h2>Article 9 - INEXECUTION</h2>
            <p>
                9.1 - En cas d'inexécution par le client de l'une des obligations et notamment en cas de non règlement à l'échéance convenue des sommes dues au titre des abonnements ou factures de services, et sans qu'il soit nécessaire au Centre ELYSEE SERVICES d'adresser une mise en demeure préalable, le Centre ELYSEE SERVICES sera en droit :
            </p>
            <ul>
                <li>de suspendre l'exécution des commandes en cours et l'ouverture aux prestations (ex : consommation téléphonique) de demander le règlement immédiat</li>

                <li>de toute opération en cours, le non paiement d'une facture à son échéance entraînant l'exigibilité immédiate des sommes dues au titre d'autres opérations.</li>

                <li>de conserver les biens mobiliers et matériels du client déposés dans les locaux du Centre ELYSEE SERVICES, le client conservant toutefois la charge des risques de perte ou de dommage desdits biens.</li>
            </ul>

            <p>9.2 - Après un délai de 8 jours calendaires suivant présentation postale par lettre recommandée avec accusé de réception d'une mise en demeure de payer, d'exécuter ou de régulariser demeurée infructueuse, ELYSEE SERVICES sera en droit:</p>
            <ul>
                <li>d'imputer aux sommes dues une pénalité de retard calculée par application d'un taux d'intérêt de retard égal à une fois et demi le taux annuel de l'intérêt légal.</li>

                <li>de résilier les contrats en cours et notamment les abonnements de domiciliation.</li>

                <li>d'exiger le montant total de l'abonnement (jusqu'à son terme contractuel) dû au Centre ELYSEE SERVICES.</li>

                <li>de conserver le dépôt de garantie versé au titre d'indemnité de résiliation.</li>
            </ul>

            <p>
                9.3 - Tout retard ou défaut d'acceptation d'un effet de commerce entraînera les mêmes conséquences qu'un retard ou défaut de paiement.
                <br /> <br />
                9.4 - En cas d'événement ou comportement du client ou de l'un de ses préposés portant une atteinte grave au bon fonctionnement du Centre ELYSEE SERVICES, ELYSEE SERVICES sera en droit :
            </p>
            <ul>
                <li>
                    de refuser l'accès au Centre ELYSEE SERVICES aux personnes concernées. Il en sera notamment ainsi en cas d'attitude injurieuse ou scandaleuse ou encore d'état d'ébriété.
                </li>
                <li>
                    de résilier et de rompre, sur le champ, toute relation commerciale.
                </li>
            </ul>
            <p>
                9.5- Le fait pour ELYSEE SERVICES de ne pas se prévaloir de l'une ou de l'autre des dispositions du présent article, ne saurait en aucun être considéré comme une renonciation de sa part au bénéfice des présentes dispositions.
            </p>
            <br />
            <h2>Article 10 - CAUTION</h2>
            <p>
                Par la signature de l'engagement de caution indéfinie et solidaire contenu dans le contrat de prestation de services, le signataire est tenu indéfiniment et solidairement des engagements du client à l'égard du Centre ELYSEE SERVICES.
            </p>
            <br />
            <h2>Article 11 - DEPOT DE GARANTIE</h2>
            <p>
                En garantie de la bonne exécution de ses obligations, le client verse une somme déterminée au contrat de prestation de services.
                <br />
                Ce dépôt de garantie n'est pas productif d'intérêt. Il est restitué au client deux mois après l'expiration des relations contractuelles, sous réserve de la bonne exécution de ses obligations, et après notamment retrait des biens déposés par lui, remise des clefs, justification de paiement de ses impôts (liée à une domiciliation fiscale au Centre ELYSEE SERVICES, communication de sa nouvelle adresse.
                <br />
                Le dépôt de garantie pourra notamment être conservé par le Centre ELYSEE SERVICES :
            </p>
            <ul>
                <li>
                    proportionnellement en cas de perte ou dégradation des biens du client constatés à l'issue du contrat et non remboursées ou indemnisées par le client.
                </li>
                <li>
                    proportionnellement, à l'issue du contrat d'avances sur consommation, en cas d'insuffisance à garantir les factures encore impayées ou en instance, accompagnée des éventuels retards dus.
                </li>

                <li>
                    n totalité en cas de résiliation anticipée du contrat au titre de l'indemnité de résiliation.
                </li>
            </ul>
            <p>
                Le dépôt de garantie variera dans les mêmes proportions que le montant du ou des abonnements du client. Le dépôt ne saurait remplacer des avances sur consommation et n'a donc pas de vocation à s'imputer sur le montant des dernières factures.
            </p>
            <br />
            <h2>Article 12 - AVANCES SUR CONSOMMATION</h2>
            <p>
                Au titre des prestations de services utilisées de façon régulière et de celles susceptibles de l'être de façon irrégulière, le client versera au Centre ELYSEE SERVICES une avance sur consommation.
                <br />
                Le client reconnaît être parfaitement informé que pour obtenir une ou des prestations quelconque de caractère régulier ou irrégulier, il faut disposer de façon préalable dans les livres du Centre ELYSEE SERVICES d'un crédit suffisant.
            </p>
            <br />
            <h2>Article 13 - FIN DU CONTRAT</h2>
            <p>
                Le client a la faculté de mettre fin à ses obligations à l'issue de la période contractuelle prévue au contrat, dénonçant celui-ci par lettre recommandée avec accusé de réception dans le cadre du délai de préavis accepté par les parties.
                <br />
                A défaut du respect de ce délai, le contrat sera renouvelé par tacite reconduction pour une nouvelle période contractuelle définie au contrat.
                <br />
                Il est ici rappelé que toute résiliation du contrat par le client qui ne coïnciderait pas avec la fin d'une période contractuelle, entraînerait l'exigibilité des sommes dues au Centre ELYSEE SERVICES jusqu'au terme contractuellement défini de ladite période.
                <br /> <br />
                En fin de contrat le client s'engage à procéder sans délai :
            </p>
            <ul>
                <li>
                    à la libération des lieux mis à disposition, ceux-ci devant être restitués libres de toute occupation et en parfait état. La seule occupation du bureau au délai du terme contractuel, constitue un renouvellement tacite du contrat pour une période équivalente à la précédente.
                </li>
                <li>à la restitution des biens mis à sa disposition.</li>
                <li>à la remise de tous biens mis en dépôt au Centre ELYSEE SERVICES (ex : archives)</li>
                <li>
                    en cas de domiciliation fiscale au Centre ELYSEE SERVICES, ou de transfert de son siège social ou de la domiciliation de l'entreprise en un autre lieu et à l'exécution des formalités correspondantes auprès des organismes chargés du suivi des entreprises (ex : Greffe du Tribunal de Commerce).
                </li>
                <li>à l'information des administrations sociales et fiscales de l'éventuel changement d'adresse.</li>
            </ul>
            <p>
                En cas de défaillance du client à procéder à ces opérations dans les 8 jours suivant la fin de la relation contractuelle, le Centre ELYSEE SERVICES est expressément autorisé :
            </p>
            <ul>
                <li>
                    à informer le Greffe du Tribunal de Commerce de la fin de la domiciliation ou de la mise à disposition d'un local.
                </li>
                <li>
                    à communiquer aux administrations fiscales l'adresse qui lui aura été indiquée par le client avant son départ et l'adresse personnelle du représentant légal de l'entreprise.
                </li>
            </ul>
            <p>
                Au terme d'un délai de trois mois à compter de la fin du contrat, le Centre ELYSEE SERVICES est autorisé à détruire les biens en dépôt dans le Centre ELYSEE SERVICES (ex : matériel, archives, etc…)
            </p>
            <br />
            <h2>Article 14 - RÉGIME LÉGAL</h2>
            <p>
                Que ce soit pour la domiciliation commerciale et fiscale ou encore pour la mise à disposition d'un local, chacun des contrats définit précisément le cadre légal des prestations assurées par le Centre ELYSEE SERVICES.

            </p>
            <br />
            <h2>Article 15 - INTERDICTION DE CESSION</h2>
            <p>
                A aucun moment, ni à aucun titre, le client ne peut céder à un tiers, personne physique ou morale, les droits qu'il détient des contrats consentis par le Centre ELYSEE SERVICES.
            </p>
            <br />
            <h2>Article 16 - COMPÉTENCE</h2>
            <p>
                Tout litige quant à l'interprétation ou l'exécution des présentes sera soumis à la compétence des juridictions du siège social du Centre ELYSEE SERVICES concerné.
            </p>
            <br />
            <h2>Article 17 - ÉLÉCTION DE DOMICILE</h2>
            <p>
                Pour l'exécution des présentes, les parties font l'élection de domicile:
            </p>
            <ul>
                <li>pour le Centre ELYSEE SERVICES dans les locaux du Centre ELYSEE SERVICES.</li>

                <li>
                    pour le client en cas de domiciliation et pendant la durée de la domiciliation au Centre ELYSEE SERVICES hors les cas de domiciliation ou à la fin de la domiciliation à l'adresse indiquée sur les conditions particulières.
                </li>
            </ul>
        </b-container>

        <Sidebar />

        <MainFooter />
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    import MainHeader from '../components/MainHeader.vue'
    import Sidebar from '../components/Sidebar.vue'
    import MainFooter from '../components/MainFooter.vue'

    export default {
        components: {
            MainHeader,
            Sidebar,
            MainFooter
        },
        computed: {
            ...mapState(['services'])
        }
    }
</script>
